document.querySelectorAll('.rp-reassurance__splide').forEach(function(el) {
  new Splide(el, {
    /* mediaQuery 'min' → les breakpoints s'appliquent à partir d'une largeur mini */
    mediaQuery   : 'min',
    /* Base = mobile : slider auto 1 par 1 */
    type         : 'loop',
    perPage      : 1,
    autoplay     : true,
    interval     : 3500,
    pauseOnHover : true,
    resetProgress: false,
    pagination   : false,
    arrows       : false,
    gap          : '1.5rem',
    breakpoints  : {
      /* ≥ 990px (desktop) : on DÉTRUIT le slider → rangée statique (gérée en CSS) */
      990: { destroy: true }
    }
  }).mount();
});
